<template>
  <TheGreyWrapper v-if="opportunity">
    <TheHeader
      back-route=".."
      force-sm-style
    />
    <BaseSection>
      <BaseTitleGroup
        :title="$t('Decline a wish')"
        :subtitle="opportunity.data.attributes.name"
        class="mb-6"
      />
      <BaseParagraph class="text-grey mb-2">
        {{ $t('Decline question') }}
      </BaseParagraph>
      <form @submit.prevent="declineWish">
        <BaseTextArea
          v-focus
          v-model="wishDeclineReason"
          :min-height="80"
          :placeholder="$t('Textarea placeholder details')"
          class="mb-4"
        />
        <BaseButton
          :title="$t('Decline')"
          class="mb-8"
        />
      </form>
    </BaseSection>
  </TheGreyWrapper>
</template>

<script>
import loadOpportunity from '../mixins/loadOpportunity';
import TheHeader from '../components/TheHeader.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseParagraph from '../components/BaseParagraph.vue';
import BaseTextArea from '../components/BaseTextArea.vue';
import BaseButton from '../components/BaseButton.vue';
import TheGreyWrapper from '../components/TheGreyWrapper.vue';
import { DECLINED_OPPORTUNITY } from '../analytics';

export default {
  name: 'WishDecline',
  components: {
    TheHeader,
    BaseSection,
    BaseTitleGroup,
    BaseParagraph,
    BaseTextArea,
    BaseButton,
    TheGreyWrapper,
  },
  mixins: [loadOpportunity],
  data() {
    return {
      wishDeclineReason: null,
    };
  },
  methods: {
    declineWish() {
      this.$store.dispatch('opportunity/declineWish', {
        opportunityId: this.$route.params.id,
        wishReason: this.wishDeclineReason,
      }).then(() => {
        this.$router.push('/opportunities');
      });
      analytics.track(DECLINED_OPPORTUNITY);
    },
  },
};
</script>
